/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// NOTE - This was being applied to all files - hence returning a could not 
// clikc undefined in the console on all pages.
// the click() default tab has been moved to specific pages that need it i.e.
// the prodyct pages
// And the function openVideoTab() moved to into its own asset file tabs-control.js
// which is referenced in those product page templates

// document.getElementById("defaultTabOpen").click();

// function openVideoTab(evt, videoLanguage) {
//     // Declare all variables
//     var i, tabcontent, tablinks;

//     // Get all elements with class="tabcontent" and hide them
//     tabcontent = document.getElementsByClassName("tabcontent");
//     for (i = 0; i < tabcontent.length; i++) {
//         tabcontent[i].style.display = "none";
//     }

//     // Get all elements with class="tablinks" and remove the class "active"
//     tablinks = document.getElementsByClassName("tablinks");
//     for (i = 0; i < tablinks.length; i++) {
//         tablinks[i].className = tablinks[i].className.replace(" active", "");
//     }

//     // Show the current tab, and add an "active" class to the button that opened the tab
//     document.getElementById(videoLanguage).style.display = "block";
//     evt.currentTarget.className += " active";
// }


const swiper = new Swiper(".fv_slider", {
	loop: true,
	slidesPerView: 1,
  spaceBetween: 0,
  breakpoints: {
    860: {
      slidesPerView: 1.625,
	    centeredSlides: true,
      spaceBetween: 60,
    }
  },
  autoplay: {
    delay: 6500,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});


const aboutSlider = new Swiper(".js-FV-aboutSlider", {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 0,
  centeredSlides: true,
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    860: {
      slidesPerView: 3,
      centeredSlides: false,
    }
  }
});

const artistsSlider = new Swiper(".js-cpl-artistsSlider", {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 20,
  slideToClickedSlide: true,
  centeredSlides: true,
  breakpoints: {
    800: {
      loop: true,
      slidesPerView: 7,
      spaceBetween: 0,
      slideToClickedSlide: true,
      centeredSlides: false,
    }
  },
  on: {
    init: function () {
      renderArtist()
    },
    slideChangeTransitionEnd: function () {
      renderArtist()
    }
  },
});


$(document).on('click', '.FV-slider-arrow', function () {
  swiper.autoplay.start()
})

// $(document).on({
//   "mouseenter": function () {
//     swiper.autoplay.stop()
//   },
//   "mouseleave": function () {
//     swiper.autoplay.start()
//   }
// }, ".fv_slide.swiper-slide-active");


$(document).on('click', '.js-FV-aboutSlider-prev', function () {
  aboutSlider.slidePrev();
})

$(document).on('click', '.js-FV-aboutSlider-prev', function () {
  aboutSlider.slidePrev();
})

$(document).on('click', '.js-FV-aboutSlider-next', function () {
  aboutSlider.slideNext();
})

$(document).on('click', '.js-FV-artistsSlider-prev', function () {
  artistsSlider.slidePrev();
})

$(document).on('click', '.js-FV-artistsSlider-next', function () {
  artistsSlider.slideNext();
})

$('.js-col-collection').scroll(function () {

  const MAX_ELEMENT_WIDTH = $(this).get(0).scrollWidth;
  const ELEMENT_WIDTH = $(this).width();

  if (MAX_ELEMENT_WIDTH - ELEMENT_WIDTH - $(this).scrollLeft() < ELEMENT_WIDTH * 0.5) {
    loadNextCollectionItem(this)
  }
})

function renderArtist() {
  const elem = $('.js-cpl-artistsSlider .swiper-slide-active');
  $('.js-thumbnail').attr('src', $(elem).attr('data-thumbnail'));
  $('.js-title').text($(elem).attr('data-title'));
  $('.js-job').text($(elem).attr('data-job'));
  $('.js-selfIntroduction').text($(elem).attr('data-selfIntroduction'));

  if ($(elem).attr('data-twitter')) {
    $('.js-twitter').show();
    $('.js-twitter').attr('href', $(elem).attr('data-twitter'));
  } else {
    $('.js-twitter').hide();
  }

  if ($(elem).attr('data-instagram')) {
    $('.js-instagram').show();
    $('.js-instagram').attr('href', $(elem).attr('data-instagram'));
  } else {
    $('.js-instagram').hide();
  }
}

function loadNextCollectionItem(self) {

  const LOADING_ON = 1;
  const LOADING_OFF = 0;

  const url = $(self).attr('data-collectionUrl')
  const currentPage = $(self).attr('data-currentPage')
  const maxPage = $(self).attr('data-maxPage')
  const loading = Number($(self).attr('data-loading'))

  if (loading == LOADING_ON) {
    // ローディング中なら処理中断
    return;
  }

  if (maxPage <= currentPage) {
    // 次ページなら処理中断
    return;
  }

  const nextPage = Number(currentPage) + 1;

  $(self).attr('data-loading', LOADING_ON)

  $.ajax({
    url: url + "?page=" + nextPage,
    type: 'GET',
    dataType: 'html',
  }).done(function (res) {
    $(self).append($(res).find('.cpl-collection__item'));
    $(self).attr('data-currentPage', nextPage);

  }).fail((function (error) {
    console.log(error);
  })).always(function () {
    $(self).attr('data-loading', LOADING_OFF)
  })

}

$(function() {
		
  $(document).on('click', '.c-plus-faq-qBox__item', function() {
    var block = $(this).find('.c-plus-faq-qBox__item__A').css("display");

    if (block == 'none') {
      $(this).find('.c-plus-faq-qBox__item__A').slideDown()
      $(this).find('.c-plus-faq-qBox__item__arrow').addClass('c-plus-faq-qBox__item__arrow--open');
    } else {
      $(this).find('.c-plus-faq-qBox__item__A').slideUp()
      $(this).find('.c-plus-faq-qBox__item__arrow').removeClass('c-plus-faq-qBox__item__arrow--open');
    }
  })

})

$(function(){
  $('.js-registerCheckbox').change(function(){
    let submitBtnCustomData = $(this).data('checkboxTarget');
    $(`input[${submitBtnCustomData}]`).prop('disabled', !$(this).prop('checked'));
  });

});

if ($(window).width() < 600) {
  $('.js-ypPrivilegeList').hide();
}

$(document).on('click', '.js-toggleYpPrivilege', function () {
  $('.js-ypPrivilegeList').slideToggle();
})

$(document).on('click', '.js-customLangifyBtn', function () {
  const langId = $(this).data('lang')
  console.log(langId)

  $('#ly-languages-switcher').val(langId);
  $('#ly-languages-switcher').trigger('change');
})

function renderLangifySelectedLanguage() {
  const selectedLanguage = langify.helper.getSelectedLanguage()

  $(`.js-customLangifyBtn[data-lang="${selectedLanguage}"]`).addClass('customLanguageSwitcher__btn--active')
}

renderLangifySelectedLanguage()